// extracted by mini-css-extract-plugin
module.exports = {"walletConnectModal":"wallet_connect_modal_walletConnectModal__1zZFK"};